// app/books/book.service.ts
import { Injectable } from '@angular/core';
import { ResourceAction, ResourceParams, IResourceMethodPromise } from '@ngx-resource/core';
import { RestClient } from './rest.client';
import { environment } from '../../environments/environment';
// Interfaces
import { IBlog } from '../interfaces/IBlog';
// Import RxJs required methods

interface IoBlogs {
    data: any;
}

@Injectable()
@ResourceParams({
    url: `${environment.url.api}`,
    pathPrefix: '/api/blog'
})
export class BlogService extends RestClient {

    @ResourceAction({
        path: '/'
    })
    getBlogList: IResourceMethodPromise<{ page: any, size: any }, IoBlogs>;

    @ResourceAction({
        path: '/{:id}'
    })
    getBlog: IResourceMethodPromise<{ id: any }, IBlog>;

    @ResourceAction({
        path: '/incrementview/{:id}'
    })
    incrementView: IResourceMethodPromise<{ id: any }, IBlog>;
}
